/*
  一覧の頁 (札や表が並ぶ頁) の本文の列の幅。帯 (PublicPageBand の column) と本文の器の両方がここを読み、左右の端をそろえる。

  1232px は、768px 以上の左右の余白 40px を引いた中身が 1152px になる値。1152px は共通の頭 (ヘッダー) の中身の幅と同じで、
  1440 でも 1280 でも、ロゴの左の端、帯の題、札の並びの左の端が同じ所に立つ。札は 1280px から 4 列で 1 枚 276px。
  それより広げると、ヘッダーより本文が外へはみ出して見え、札 1 枚の中の字の行も伸びすぎる。

  読み物の段落は広げない (10/26 代表)。器の中の p は 860px で止め (:where で包み、p に付いた max-w の方が勝つ)、行の長さを今までの読み物の列と同じに保つ。
  札の中の説明 (276px) と表には効かない
*/
export const LIST_COLUMN = { max: 1232, pad: 40 } as const;

/** 本文の器。帯の column と同じ幅と余白 (スマホ 16px、640px から 20px、768px から 40px) */
export const LIST_COLUMN_WRAP = "mx-auto w-full max-w-[1232px] px-4 sm:px-5 md:px-10 [:where(&)_p]:max-w-[860px]";
